import type { GroundPiece } from '../../site/types';
import type { AABB, PolygonWithHoles } from '../../geo/types';
import { ringBounds } from '../../geo/polygon';
import { fromRing, intersection } from '../../geo/clip';

export const GROUND_CHUNK_M = 2000;

/** Clip only the pieces touching a tile, inside its build job rather than blocking job planning. */
export function groundChunkJobs(pieces: readonly GroundPiece[], bounds: AABB) {
  const boxes = pieces.map((piece) => ({ piece, box: ringBounds(piece.polygon.outer) }));
  const jobs: {
    x: number;
    y: number;
    pieceCount: number;
    pieces: (from?: number, to?: number) => readonly GroundPiece[];
  }[] = [];
  for (let y = bounds.minY; y < bounds.maxY; y += GROUND_CHUNK_M) {
    for (let x = bounds.minX; x < bounds.maxX; x += GROUND_CHUNK_M) {
      const right = Math.min(x + GROUND_CHUNK_M, bounds.maxX);
      const top = Math.min(y + GROUND_CHUNK_M, bounds.maxY);
      const near = boxes.filter(
        ({ box }) => box.minX < right && box.maxX > x && box.minY < top && box.maxY > y
      );
      if (!near.length) continue;
      const tile: PolygonWithHoles = fromRing([
        [x, y],
        [right, y],
        [right, top],
        [x, top],
      ]);
      jobs.push({
        x,
        y,
        pieceCount: near.length,
        pieces: (from = 0, to = near.length) =>
          near
            .slice(from, to)
            .flatMap(({ piece }) =>
              intersection([piece.polygon], [tile]).map((polygon) => ({ ...piece, polygon }))
            ),
      });
    }
  }
  return jobs;
}
